"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoyStructDecorated = exports.JoyStructCustom = void 0;
const codec_1 = require("@polkadot/types/codec");
// Helper for creating extended Struct type with TS-compatible interface
// It's called JoyStructCustom, because eventually we'd want to migrate all structs to JoyStructDecorated,
// but the latter won't allow specifying getters that return different type than the original field type.
// (ie. by using getString() instead of getField())
function JoyStructCustom(fields) {
    var _a;
    return _a = class JoyStructObject extends codec_1.Struct.with(fields) {
            // eslint-disable-next-line no-useless-constructor
            constructor(registry, value) {
                super(registry, value);
                this.typeDefs = JoyStructObject.typeDefs;
            }
            getField(key) {
                return this.get(key);
            }
            getString(key) {
                return this.getField(key).toString();
            }
            // TODO: Check why would this ever be needed
            cloneValues() {
                const objectClone = {};
                super.forEach((v, k) => {
                    objectClone[k] = v; // shallow copy acceptable ?
                });
                return objectClone;
            }
        },
        _a.typeDefs = fields,
        _a;
}
exports.JoyStructCustom = JoyStructCustom;
// JoyStruct enriched with typescript definitions for getters automatically added by polkadot-js
function JoyStructDecorated(fields) {
    // We need to cast here because there's no way to make TS aware of getters added with Object.defineProperty
    return JoyStructCustom(fields);
}
exports.JoyStructDecorated = JoyStructDecorated;
